import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getDiscountPrice } from "../../../helpers/product";
import { selectCartState, removeFromCart, fetchCartItems } from "../../../../../redux/WithcookieSlice";
import { PriceDisplay } from "../../../../../components/common/PriceDisplay";

const MenuCart = () => {
  const dispatch = useDispatch();
  const currency = useSelector((state) => state.currency);
  const { cartItems } = useSelector(selectCartState);
  let cartTotalPrice = 0;

  const handleRemoveFromCart = async (cartItemId) => {
    try {
      await dispatch(removeFromCart(cartItemId)).unwrap();
      await dispatch(fetchCartItems());
    } catch (error) {
      console.error('장바구니 상품 삭제 중 오류:', error);
    }
  };

  return (
    <div className="shopping-cart-content">
      {cartItems && cartItems.length > 0 ? (
        <Fragment>
          <ul>
            {cartItems.map((item) => {
              // product 정보와 가격 가져오기
              const product = item.product || {};
              const config = product.config || {};
              const discountedPrice = config.discounted_price ? Number(config.discounted_price) : 0;
              const defaultPrice = config.default_price ? Number(config.default_price) : 0;
              const price = discountedPrice || defaultPrice;
              const count = item.count || 1;
              
              // 합계 가격 계산
              cartTotalPrice += price * count;

              return (
                <li className="single-shopping-cart" key={item.id}>
                  <div className="shopping-cart-img">
                    <Link to={`/products/${product.id}`}>
                      {config.img_url ? (
                        <img
                          alt={product.title || "상품 이미지"}
                          src={config.img_url}
                          className="img-fluid"
                        />
                      ) : (
                        <div className="no-image">No Image</div>
                      )}
                    </Link>
                  </div>
                  <div className="shopping-cart-title">
                    <h4>
                      <Link to={`/products/${product.id}`}>
                        {product.title || "상품"}
                      </Link>
                    </h4>
                    <h6>수량: {count}</h6>
                    <span>
                      {price ? <PriceDisplay price={price} /> : '가격 정보 없음'}
                    </span>
                  </div>
                  <div className="shopping-cart-delete">
                    <button onClick={() => handleRemoveFromCart(item.id)}>
                      <i className="fa fa-times-circle" />
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
          <div className="shopping-cart-total">
            <h4>
              합계:{" "}
              <span className="shop-total">
                <PriceDisplay price={cartTotalPrice} />
              </span>
            </h4>
          </div>
          <div className="shopping-cart-btn btn-hover text-center">
            <Link className="default-btn" to="/cart">
              장바구니 보기
            </Link>
            <Link
              className="default-btn"
              to="/checkout"
            >
              결제하기
            </Link>
          </div>
        </Fragment>
      ) : (
        <p className="text-center">장바구니가 비어있습니다.</p>
      )}
    </div>
  );
};

export default MenuCart;
